import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-frontend-tech }}\n{{yield this.collapsed}}",{ moduleName: "embercom/components/common/navbar-collapsed.hbs" })